import script from "./LatestArticlesSection.vue?vue&type=script&setup=true&lang=js"
export * from "./LatestArticlesSection.vue?vue&type=script&setup=true&lang=js"

import "./LatestArticlesSection.vue?vue&type=style&index=0&id=693e7877&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-693e7877"]])

export default __exports__